<template>
    <div style="margin: 0 auto;" :style="$q.platform.is.mobile ? 'width: 90vw;' : 'width: 60vw;'">
        <vue-plyr ref="plyr" :options="{ listeners: { seek: activity.user_watch ? '' : seekVideo } }">
            <video playsinline webkit-playsinline ref="player" id="player">
                <source :src="`${getResource}#t=${activity.current_time}`" :type="getType">
            </video>
        </vue-plyr>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import 'dashjs'
import Plyr from 'plyr'

export default {
    props: ['activity', 'closing', 'display'],

    data() {
        return {
            id_course: '',
            id_trail: '',
            interval: null,
            current_time: 0,
            total_time: '',
            changed_time: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getResource() {
            // if (this.activity.video_playlist_mpd && !this.$q.platform.is.ios) return this.activity.video_playlist_mpd
            // else if (this.activity.video_playlist_m3u8 && this.$q.platform.is.ios) return this.activity.video_playlist_m3u8
            // else if (this.activity.resource) return this.activity.resource
            // else return ''
            return this.activity.resource
        },

        getType() {
            // if (this.activity.video_playlist_mpd && !this.$q.platform.is.ios) return 'application/dash+xml'
            // else if (this.activity.video_playlist_m3u8 && this.$q.platform.is.ios) return 'application/x-mpegURL'
            // else if (this.activity.resource) return this.$mime.lookup(this.activity.resource.split('?')[0])
            // else return ''
            return this.$mime.lookup(this.activity.resource.split('?')[0])
        },

        player () {
            return this.$refs.plyr.player
        }
    },

    methods: {
        sendPosition() {
            if (this.current_time != 0) {
                let fd = new FormData()
                fd.append('current_time', this.current_time)
                fd.append('total_time', this.total_time)
                fd.append('id_group_training_module', this.activity.type_id)

                let url = ''
                if (this.id_trail == "") {
                    url = `/etraining_courses/group_training/${this.id_course}/set_group_training_module_user_progress/`
                }
                else {
                    url = `/etraining_trails/trail/${this.id_trail}/group_training/${this.id_course}/set_group_training_module_user_progress/`
                }

                this.$axios.post(url, fd, this.getHeader)
                .then(response => {

                })
                .catch(e => {
                    console.log(e)
                })
            }
        },

        playVideo() {
            if (!this.changed_time) {
                this.player.currentTime = this.activity.current_time
                this.changed_time = true
            }

            this.interval = setInterval(() => {
                this.sendPosition()
            }, 30000)
        },

        pauseVideo() {
            this.sendPosition()
            clearInterval(this.interval)
        },

        videoTimeUpdated(val) {
            this.current_time = val.detail.plyr.currentTime
        },

        metaData(val) {
            this.total_time = val.detail.plyr.media.duration
        },

        seekVideo(e) {

        },

        enterfullscreen(e) {
            this.$emit('display', 'none')
        },

        exitfullscreen(e) {
            this.$emit('display', 'flex')
        }
    },

    watch: {
        closing: function(val) {
            if (val == true) {
                this.sendPosition()
                clearInterval(this.interval)
                this.changed_time = false
                this.$emit('positionSent')
            }
        }
    },

    mounted () {
        this.player.on('timeupdate', (val) => this.videoTimeUpdated(val))
        this.player.on('loadedmetadata', (val) => this.metaData(val))
        this.player.on('play', (val) => this.playVideo())
        this.player.on('pause', (val) => this.pauseVideo())
        this.player.on('enterfullscreen', (val) => this.enterfullscreen(val))
        this.player.on('exitfullscreen', (val) => this.exitfullscreen(val))

        // if (this.activity.video_playlist_mpd && !this.$q.platform.is.ios) {
        //     let dash = dashjs.MediaPlayer().create()
        //     let video = this.$refs.player
        //     dash.initialize(video, this.activity.video_playlist_mpd, true)
        // }
        // else if (this.activity.video_playlist_m3u8 && this.$q.platform.is.ios) {
        //     let dash = dashjs.MediaPlayer().create()
        //     let video = this.$refs.player
        //     dash.initialize(video, this.activity.video_playlist_m3u8, true)
        // }
    },

    created() {
        if( this.$route.params.id_trail) this.id_trail = this.$route.params.id_trail
        if( this.$route.params.id) this.id_course = this.$route.params.id
    }
}
</script>

<style lang="stylus" scoped>
</style>
